import { render } from "./PageComponents.vue?vue&type=template&id=0356938a"
import script from "./PageComponents.vue?vue&type=script&lang=js"
export * from "./PageComponents.vue?vue&type=script&lang=js"

import "./PageComponents.vue?vue&type=style&index=0&id=0356938a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__